<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="举报人" prop="nickname" >-->
<!--        <a-input readOnly v-model="form.nickname" placeholder="请输入用户ID｛user.id｝" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="评论内容" prop="comment" >
        <a-input  readOnly v-model="form.comment" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="举报原因" prop="content" >
        <a-input readOnly v-model="form.content"  type="textarea"/>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-radio-group v-model="form.status" @change="changeStatus">
          <a-radio :value="0">待审核</a-radio>
          <a-radio :value="1">通过</a-radio>
          <a-radio :value="2">驳回</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="禁言类型" prop="forbidType" v-if="form.status == 1">
        <a-radio-group v-model="form.forbidType">
          <a-radio :value="1">永久</a-radio>
          <a-radio :value="2">自定义</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="禁言截止时间" prop="forbidDeadline" v-if="form.forbidType == 2">
        <a-date-picker style="width: 100%" v-model="form.forbidDeadline" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="驳回原因" prop="rejectReason" v-if="form.status == 2">
        <a-input v-model="form.rejectReason" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCommentReport, addCommentReport, updateCommentReport } from '@/api/tree/commentReport'
import Editor from '@/components/Editor'
import moment from "moment";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        commentId: null,

        comment: null,

        status: 0,

        content: null,

        rejectReason: null,

        createTime: null,

        remark: null,
        forbidDeadline:null,
        forbidType:null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID｛user.id｝不能为空', trigger: 'blur' }
        ],
        commentId: [
          { required: true, message: '评论ID｛tree_comment.id｝不能为空', trigger: 'blur' }
        ],
        comment: [
          { required: true, message: '评论内容不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'blur' }
        ],
        forbidType: [
          { required: true, message: '禁言类型不能为空', trigger: 'blur' }
        ],
        forbidDeadline:[{
          required: true, message: '禁言截止时间不能为空', trigger: 'blur'
        }],
        // rejectReason:[{
        //   required: true, message: '驳回原因不能为空', trigger: 'blur'
        // }],
        content: [
          { required: true, message: '举报原因不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        commentId: null,
        comment: null,
        status: 0,
        content: null,
        rejectReason: null,
        forbidType:null,
        forbidDeadline:null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    changeStatus(val){
      this.form.forbidType = null
      this.form.forbidDeadline = null
      this.form.rejectReason = null
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommentReport({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        this.form.forbidType = 1
        this.form.forbidDeadline = null
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.form.forbidDeadline){
            this.form.forbidDeadline =  moment(this.form.forbidDeadline).format('YYYY-MM-DD HH:mm:ss')
          }
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCommentReport(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCommentReport(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
